module.exports = __webpack_public_path__ + "static/media/Certificate_Design_-_Arabic_Final-01.9ab5e76f.png";